"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnHrefClick = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
const shouldOpen = (href, target) => {
  // document.activeElement points to the element that currently has focus,
  // usually it is the most recent thing that was clicked (and can be focused).
  // This is what we actually need when clicking anything wrapped in an Anchor -
  // - image or other passive elements cannot have focus so it goes to the wrapping anchor.
  if (document.activeElement) {
    return document.activeElement instanceof HTMLAnchorElement && document.activeElement.hash === href;
  }

  // fallback code for the 0.1% cases where document does not provide activeElement -
  // - pick the event target and if it is not an Anchor, see if any of its parents is.
  // If we don't find one, stop at Body - there's nothing of interest upwards.
  let bubblingTarget = target;
  while (bubblingTarget && !(bubblingTarget instanceof HTMLBodyElement)) {
    if (bubblingTarget instanceof HTMLAnchorElement) {
      return bubblingTarget.hash === href;
    }
    bubblingTarget = bubblingTarget.parentElement;
  }
  return false;
};
const deleteHash = () => {
  window.location.hash = '';
};
const useOnHrefClick = ({
  href,
  onClick
}) => {
  const onHashChange = (0, _react.useCallback)(event => {
    const newUrl = new URL(event.newURL);
    if (newUrl.hash === href) {
      onClick();
      deleteHash();
    }
  }, [href, onClick]);
  const events = (0, _react.useMemo)(() => [{
    name: 'hashchange',
    listener: onHashChange
  }], [onHashChange]);
  (0, _presentationHooks.useGlobalEvents)(events);
  (0, _react.useEffect)(() => {
    const onOpen = event => {
      if (shouldOpen(href, event.target)) {
        event.preventDefault();
        onClick();
      }
    };
    document.addEventListener('click', onOpen);
    return () => document.removeEventListener('click', onOpen);
  }, [href, onClick, onHashChange]);
};
exports.useOnHrefClick = useOnHrefClick;